export interface TimelineItem {
  year: string;
  title: string;
  description: string;
}

export interface HonorItem {
  year: string;
  title: string;
  issuer: string;
  image: string;
}

export interface TeamMember {
  id: string;
  name: string;
  role: string;
  image: string;
  description: string;
}

export const companyStats = [
  { value: '10+', label: '年行业经验' },
  { value: '1000万+', label: '累计销量' },
  { value: '50+', label: '专利技术' },
  { value: '300+', label: '经销网点' }
];

export const honors = [
  { year: '2018', title: '临湘市钓具电子商务协会会长单位', issuer: '临湘市钓具电子商务协会', image: '/images/honors/honor-2018-1.jpg' },
  { year: '2018', title: '临湘浮标地理标志证明商标授权', issuer: '临湘市浮标产业发展领导小组办公室', image: '/images/honors/honor-2018-5.jpg' },
  { year: '2018', title: '临湘市钓具（浮标）诚信企业', issuer: '临湘市浮标协会', image: '/images/honors/honor-2018cx.jpg' },
  { year: '2017', title: '临湘十佳优秀品牌', issuer: '临湘市浮标（钓具）发展领导小组', image: '/images/honors/honor-2017-7.jpg' },
  { year: '2017', title: '湖南省电子商务认定企业', issuer: '临湘市商务粮食局', image: '/images/honors/honor-2017.jpg' },
  { year: '2016', title: '最受消费者欢迎产品', issuer: '湖南浩天钓具用品展览会组委会', image: '/images/honors/honor-2016.jpg' },
  { year: '2015', title: '临湘市青年创业实践基地', issuer: '共青团临湘市委', image: '/images/honors/honor-2015.jpg' },
  { year: '2014', title: '中国浮漂行业标准制定单位', issuer: '临湘市钓具电子商务协会', image: '/images/honors/fphybz.jpg' }
];

export const timeline: TimelineItem[] = [
  {
    year: '2013',
    title: '品牌正式进入市场',
    description: '渔我同乐品牌产品正式进入市场开始发售，经过不断的发展，深受用户信赖与好评，公司已通过ISO9001质量管理体系认证，同年通过ISO14001环境管理体系认证。公司拥有"民间艺人"、"子赢"等产品品牌，研发出了一系列时尚、个性化的产品，并致力于让休闲垂钓成为一种生活方式，成为一种竞技运动。'
  },
  {
    year: '2014',
    title: '加入浮标协会 & 成立总公司',
    description: '正式加入"临湘市浮标协会"理事单位，副会长单位。同年成立湖南总公司办公基地，致力商务覆盖全国。'
  },
  {
    year: '2015',
    title: '电商平台飞速发展',
    description: '公司互联网商务平台产品销量连续几年飞速增长，渔具销量遥遥领先。'
  },
  {
    year: '2016',
    title: '荣获十佳品牌 & 研发中心迁入',
    description: '公司旗下产品品牌"民间艺人"被评为"浮漂十佳品牌"，同年公司产品研发中心迁入临湘市浮漂产业园。'
  },
  {
    year: '2017',
    title: '成立钓友俱乐部',
    description: '公司成立钓友俱乐部，组建专业战队，赞助各大赛事，影响力与日俱增。'
  },
  {
    year: '2018',
    title: '成为电子商务协会会长单位',
    description: '公司正式加入临湘市钓具电子商务协会会长单位。'
  },
  {
    year: '2019',
    title: '组建自媒体团队',
    description: '公司开始组建自媒体团队，开始运营"抖音""快手"等直播平台的销售渠道。'
  },
  {
    year: '2020',
    title: '搬迁至标准化厂房',
    description: '公司搬迁至标准化厂房，将生产销售仓储聚为一体，公司取得了辉煌的销售业绩。'
  },
  {
    year: '2022',
    title: '荣获企业标准"领跑者"单位',
    description: '公司荣获国家质量监督总局认定的企业标准"领跑者"单位，是行业标准制定者单位之一。'
  },
  {
    year: '2023',
    title: '成立纳米浮漂研究院',
    description: '公司成立行业首个纳米浮漂研究院，追求品牌的专业化，为民间艺人品牌的长期发展夯实基础。'
  },
  {
    year: '2024',
    title: '长沙分公司成立',
    description: '长沙分公司成立同年6月被市质量监督局评为标准创新型企业。'
  }
  ];

export const teamMembers: TeamMember[] = [
  {
    id: 'team-001',
    name: '张工匠',
    role: '创始人 / 首席工艺师',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
    description: '从事浮漂制作30余年，精通传统手工技艺，主导研发GH系列浮漂。'
  },
  {
    id: 'team-002',
    name: '李研发',
    role: '技术总监',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face',
    description: '材料学博士，负责新材料研发和产品创新，拥有20余项专利技术。'
  },
  {
    id: 'team-003',
    name: '王设计',
    role: '设计总监',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face',
    description: '工业设计专家，负责产品外观和用户体验设计，打造新中式美学风格。'
  },
  {
    id: 'team-004',
    name: '陈质检',
    role: '质量总监',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face',
    description: '质量管控专家，建立完善的质检体系，确保每一支浮漂的品质。'
  }
];

export const companyInfo = {
  name: '民间艺人渔具有限公司',
  founded: '2012年',
  employees: '150+',
  description: `公司坐落于"中国浮标之乡"湖南临湘，2012年由4位热爱钓鱼事业的创始人创立，是集浮漂研发、设计、生产、销售、仓储物流于一体的现代化钓具企业，也是临湘浮漂百亿产业集群核心龙头企业之一。

现有150名专业制作工人，高级技工占比30%，坚守"匠心造漂、诚信经营"理念，依托临湘百年浮漂非遗技艺与现代工艺，打造高性价比、高适配性的垂钓浮漂产品，旗下"民间艺人（FOLK ARTISTS）"品牌稳居行业头部，线上线下渠道全覆盖，产品远销全国，累计服务数千万钓友，同时积极助力行业人才培育，承办政府电商与技能培训，推动临湘浮漂产业规范化、品牌化发展。`,
mission: '为了亿万钓友及家庭的幸福',
vision: '成为一家伟大的钓具企业',
values: '人品、企品、产品三品合一'
};
